export default __webpack_public_path__ + "static/media/api-token-one.65a15025.png";